<template>
	<modal :id="ref" :ref="ref" :closeProp="close" title="Impostazioni Importi">
		<form :id="refForm" :ref="refForm">
			<form-segment
				name="oneoff"
				id="oneoffForm"
				label="OneOff"
				:options="[
					{ label: 'Attivo', value: '1' },
					{ label: 'Disattivo', value: '0' },
				]"
				:value="getValue('oneoff')"
			></form-segment>
			<form-input
				name="oneoff_label"
				id="oneoffLabel"
				label="OneOff: Label"
				placeholder="OneOff"
				:value="getValue('oneoff_label')"
			></form-input>
			<form-segment
				name="recurrent"
				id="recurrentForm"
				label="Mensile"
				:options="[
					{ label: 'Attivo', value: '1' },
					{ label: 'Disattivo', value: '0' },
				]"
				:value="getValue('recurrent')"
			></form-segment>
			<form-input
				name="recurrent_label"
				id="recurrentLabel"
				label="Mensile: Label"
				placeholder="Mensile"
				:value="getValue('recurrent_label')"
			></form-input>
			<form-segment
				name="annual"
				id="annualForm"
				label="Annuale"
				:options="[
					{ label: 'Attivo', value: '1' },
					{ label: 'Disattivo', value: '0' },
				]"
				:value="getValue('annual')"
			></form-segment>
			<form-input
				name="annual_label"
				id="annualLabel"
				label="Annuale: Label"
				placeholder="Annuale"
				:value="getValue('annual_label')"
			></form-input>

			<form-segment
				name="default"
				id="defaultForm"
				label="Default"
				:options="[
					{ label: 'OneOff', value: '0' },
					{ label: 'Mensile', value: '1' },
					{ label: 'Annuale', value: '2' },
				]"
				:value="getValue('default')"
			></form-segment>

			<form-segment
				name="custom_amount"
				id="customAmountForm"
				label="Valore Personalizzato"
				:options="[
					{ label: 'Attivo', value: '1' },
					{ label: 'Disattivo', value: '0' },
				]"
				:value="getValue('custom_amount')"
			></form-segment>

			<div class="row">
				<div class="col-md-6">
					<form-input
						name="oneoff_custom_min"
						type="number"
						id="oneoffCustomMin"
						label="OneOff: Minimo"
						small="Default: 1"
						:value="getValue('oneoff_custom_min')"
					></form-input>
				</div>
				<div class="col-md-6">
					<form-input
						name="oneoff_custom_max"
						type="number"
						id="oneoffCustomMax"
						label="OneOff: Massimo"
						:value="getValue('oneoff_custom_max')"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-input
						name="recurrent_custom_min"
						type="number"
						id="recurrentCustomMin"
						label="Ricorrenti Mensili: Minimo"
						small="Default: 1"
						:value="getValue('recurrent_custom_min')"
					></form-input>
				</div>
				<div class="col-md-6">
					<form-input
						name="recurrent_custom_max"
						type="number"
						id="recurrentCustomMax"
						label="Ricorrenti Mensili: Massimo"
						:value="getValue('recurrent_custom_max')"
					></form-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<form-input
						name="recurrent_annual_custom_min"
						type="number"
						id="recurrentCustomAnnualMin"
						label="Ricorrenti Annuali: Minimo"
						small="Default: 1"
						:value="getValue('recurrent_annual_custom_min')"
					></form-input>
				</div>
				<div class="col-md-6">
					<form-input
						name="recurrent_annual_custom_max"
						type="number"
						id="recurrentCustomAnnualMax"
						label="Ricorrenti Annuali: Massimo"
						:value="getValue('recurrent_annual_custom_max')"
					></form-input>
				</div>
			</div>

			<form-textarea
				name="recurrent_message_text"
				id="recurrentMessageText"
				placeholder="Inserisci il messaggio relativo ai pagamenti ricorrenti"
				label="Messaggio Ricorrenti"
				:value="getValue('recurrent_message_text')"
			></form-textarea>

			<form-segment
				name="show_description_in_button"
				id="showDescriptionInButtonForm"
				label="Mostra Descrizione nel Bottone Importo"
				:options="[
					{ label: 'Si', value: '1' },
					{ label: 'No', value: '0' },
				]"
				:value="getValue('show_description_in_button')"
			></form-segment>
		</form>

		<template v-slot:footer>
			<btn type="success" :icon="['far', 'check']" title="Salva" :action="submitForm"></btn>
		</template>
	</modal>
</template>

<script>
export default {
	data: () => ({
		ref: 'payments_type',
		refForm: '',
		urlupdate: '',
		id: '',
		datas: {},
	}),
	props: {
		urlstore: {
			type: String,
			default: '',
			required: true,
		},
		reftable: {
			type: String,
			default: '',
			required: false,
		},
		amountType: {
			type: Object,
			default: () => {},
			required: false,
		},
	},
	created: function () {
		this.refForm = this.ref + 'DataForm'

		if (!!this.amountType && typeof this.amountType === 'object') {
			if (!!this.amountType.urlupdate) this.urlupdate = this.amountType.urlupdate
			if (!!this.amountType.datas) this.assignData(this.amountType.datas)
		} else {
			this.assignData({})
		}
	},
	methods: {
		close: function () {
			//this.assignData({})
			//this.urlupdate = ''

			this.$refs[this.ref].close()
		},
		open: function (data) {
			/*if (!!data && typeof data === 'object') {
				if (!!data.urlupdate) this.urlupdate = data.urlupdate
				if (!!data.datas) this.assignData(data.datas)
			} else if (!!data && Array.isArray(data)) {
				this.assignData(data)
			} else {
				this.assignData({})
			}*/

			this.$refs[this.ref].open()
		},
		getValue: function (key, defaultValue) {
			if (key === '') return this.datas
			else if (!!this.datas[key]) return this.datas[key]
			else if (this.datas[key] === 0 || this.datas[key] === '0' || this.datas[key] === false)
				return this.datas[key]
			else if (!!defaultValue) return defaultValue
			else return ''
		},
		getAction: function () {
			return !!this.id ? this.urlupdate : this.urlstore
		},
		getMethod: function () {
			return !!this.id ? 'PATCH' : 'POST'
		},
		assignData: function (datas) {
			if (!datas) return false

			if (!!Object.keys(datas).length) {
				this.datas = datas
				if (!!datas.id) this.id = datas.id
			} else {
				this.datas = {}
				this.id = ''
			}
		},
		submitForm: function () {
			return this.$root.request(
				this,
				this.getAction(),
				this.getMethod(),
				this.$root.getParamsFromForm(this.$refs[this.refForm]),
				this.submitFormCallback
			)
		},
		submitFormCallback: function (data) {
			if (!!this.reftable) this.$root.tableRefresh(this.reftable)

			this.close()
		},
	},
}
</script>
